export const environment = {
  production: true,
  gqlUrl: "https://janovskatraktoriada.herokuapp.com/graphql"
};